import React, { useContext } from 'react'
import { Box } from '@chakra-ui/react'
import { LayoutContext } from './Layout'
import { LayoutOverlay } from './LayoutOverlay'

export const MobilePanel = ({ children }) => {
  const { isRightPanelOpen, onToggleRightPanel } = useContext(LayoutContext)
  return (
    <>
      <LayoutOverlay
        showOverlay={isRightPanelOpen}
        onClick={() => onToggleRightPanel(!isRightPanelOpen)}
      />
      <Box
        backgroundColor="white"
        position="fixed"
        top={0}
        bottom={0}
        left={0}
        right={0}
        width="100vw"
        transition=".4s transform"
        transform={
          !isRightPanelOpen
            ? 'translate3D(0, 100vh, 0)'
            : 'translate3D(0, 100px, 0)'
        }
        zIndex={2001}
        boxShadow="0 -10px 10px rgba(0, 0, 0, .1)"
        className="right-panel"
      >
        <Box
          width="100%"
          height="100%"
          overflow="hidden"
        >
          {children}
        </Box>
      </Box>
    </>
  )
}
